import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Api from '../../../services/Api';
import './LiveInput.scss';

const LiveInput = ({
  id,
  fieldName,
  endpoint,
  placeholder,
  separateControls,
  value,
  onSave,
  fontSize,
}) => {
  const [inputState, setInputState] = useState({
    value,
    lastSavedValue: value,
    editMode: false,
  });

  const handleChange = (ev) => {
    setInputState({ ...inputState, value: ev.target.value });
  };

  const cancel = () => {
    setInputState(prevState => ({
      ...inputState,
      value: prevState.lastSavedValue,
      editMode: false,
    }));
  };

  const save = async () => {
    const requestData = {};
    requestData[fieldName] = inputState.value;
    setInputState({ ...inputState, editMode: false });
    try {
      const callback = (response) => {
        if (response.status === 200) {
          setInputState({
            editMode: false,
            lastSavedValue: inputState.value,
            value: inputState.value,
          });
          if (onSave) {
            onSave(value);
          }
        } else {
          setInputState({
            ...inputState,
            editMode: true,
            value: inputState.lastSavedValue,
          });
        }
      };
      await Api.patch(`${endpoint}/${id}`, requestData).then(callback);
    } catch (err) {
      setInputState({
        ...inputState,
        editMode: true,
        value: inputState.lastSavedValue,
      });
    }
  };

  const classes = ['live-input', 'edit-mode', 'd-flex', 'align-items-center'];
  if (separateControls) {
    classes.push('separate-controls');
  }

  if (inputState.editMode) {
    return (
      <span className={classes.join(' ')}>
        <input
          className="live-input-control"
          placeholder={placeholder}
          value={inputState.value}
          onChange={ev => handleChange(ev)}
          width={200}
          style={{
            fontSize,
            height: fontSize * 2,
            width: `calc(100% - ${fontSize * 4}px)`,
          }}
        />
        <button
          type="button"
          className="cancel-button"
          onClick={() => cancel()}
          style={{
            height: fontSize * 2,
            width: fontSize * 2,
          }}
        >
          <FontAwesomeIcon icon={solid('times')} />
        </button>
        <button
          type="button"
          className="save-button"
          onClick={() => save()}
          style={{
            height: fontSize * 2,
            width: fontSize * 2,
          }}
        >
          <FontAwesomeIcon icon={solid('check')} />
        </button>
      </span>
    );
  }

  return (
    <span
      className="live-input view-mode"
      onClick={() => setInputState({ ...inputState, editMode: true })}
      style={{
        fontSize,
      }}
    >
      {
        inputState.value !== null && String(value).length > 0
          ? inputState.value
          : placeholder
      }
    </span>
  );
};

LiveInput.propTypes = {
  id: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  separateControls: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  fontSize: PropTypes.number,
};

LiveInput.defaultProps = {
  placeholder: 'N/A',
  onSave: () => { },
  separateControls: false,
  fontSize: 16,
};

export default LiveInput;
